import React, { forwardRef } from 'react';

import { useTranslation } from 'react-i18next';

import BdsDivider from '../../../../../../shared/components/v3/Globals/BdsDivider/BdsDivider';
import { IHealthReport } from '../../../../../../shared/interfaces/reports';
import { TRANSLATIONS_REPORTS } from '../../../../../../shared/translations/reports';
import SectionAnchor from '../SectionAnchor/SectionAnchor';

import './HealthOnboardingData.scss';

export const HealthOnboardingData = forwardRef(({ data }: { data: IHealthReport }, ref: React.Ref<HTMLDivElement>) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="hr-health-onboarding-header" ref={ref}>
        <SectionAnchor />
        <div className="health-report-section-title">{t(TRANSLATIONS_REPORTS.healthReport.onboarding.title)}</div>
        <div className="health-report-description">{t(TRANSLATIONS_REPORTS.healthReport.onboarding.description)}</div>
      </div>
      <div className="onboarding-data">
        <div className="onboarding-data-item">
          <div className="item-value">{data.onboardingPercentage}%</div>
          <div className="item-label">{t(TRANSLATIONS_REPORTS.healthReport.onboarding.appOnboarding)}</div>
        </div>
        <div className="onboarding-data-item">
          <div className="item-value">{data.benefitsUseIntentionPercentage}%</div>
          <div className="item-label">{t(TRANSLATIONS_REPORTS.healthReport.onboarding.benefitsInterest)}</div>
        </div>
      </div>
      <div className="hr-onboarding-divider">
        <BdsDivider size="s" color="high" />
      </div>
    </>
  );
});

HealthOnboardingData.displayName = 'HealthOnboardingData';
export default HealthOnboardingData;
